import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=213e6422&"
import script from "./BaseFooter.vue?vue&type=script&lang=js&"
export * from "./BaseFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports